export const nestEnvironments = [
    { value: 'dev', name: 'dev' },
    { value: 'qa', name: 'qa' },
    { value: 'stage', name: 'stage' },
    { value: 'prod', name: 'prod' },
];
